import * as React from "react";
import {IUser} from "../store/user/types";

interface ContextProps {
    authUser: IUser | null,
};

export const AuthUserContext = React.createContext<ContextProps>(
    {
        authUser: null
    }
);